module.exports = __webpack_public_path__ + "img/software-shape.b07302f8.png";